<template>
  <div class="figma-landing">
    <!-- Subscribe Modal -->
    <subscribe-modal
      :show="showModal"
      :plans="plans"
      :selectedPlanIndex="selectedPlanIndex"
      :formattedOfferEndsIn="formattedOfferEndsIn"
      :email="email"
      :emailInputHighlight="emailInputHighlight"
      @update:selectedPlanIndex="onModalPlanSelect"
      @update:email="email = $event"
      @subscribe="handleSubscribe"
      @close="showModal = false; email = ''"
    />

    <!-- Policy Modal -->
    <policy-modal
      :show="showPolicyModal"
      :type="policyType"
      @close="showPolicyModal = false"
    />

    <!-- Demo Video Modal -->
    <video-modal
      :show="showDemoModal"
      @close="showDemoModal = false"
    />

    <!-- Header -->
    <header class="fig-header-new" :class="{ 'scrolled': isScrolled }">
      <div class="fig-header-inner-new">
        <button class="mobile-menu-btn" @click="isMobileMenuOpen = true" aria-label="Open Menu">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
        </button>

        <a href="javascript:void(0)" @click="refreshPage" class="fig-logo-new">
          <img
            src="../assets/images/landing/figma/Makeping-Logo-Black.png"
            alt="Makeping Logo"
            class="fig-logo-img-new"
          />
        </a>

        <nav class="fig-nav-new">
          <a href="#features" @click.prevent="scrollToSection('features')" class="fig-nav-link-new" :class="{ active: activeSection === 'features' }">Features</a>
          <a href="#status-pages" @click.prevent="scrollToSection('status-pages')" class="fig-nav-link-new" :class="{ active: activeSection === 'status-pages' }">Status Pages</a>
          <a href="#integrations" @click.prevent="scrollToSection('integrations')" class="fig-nav-link-new" :class="{ active: activeSection === 'integrations' }">Integrations</a>
          <a href="#pricing" @click.prevent="scrollToSection('pricing')" class="fig-nav-link-new" :class="{ active: activeSection === 'pricing' }">Pricing</a>
          <a href="#use-cases" @click.prevent="scrollToSection('use-cases')" class="fig-nav-link-new" :class="{ active: activeSection === 'use-cases' }">Use Cases</a>
          <a href="#faq" @click.prevent="scrollToSection('faq')" class="fig-nav-link-new" :class="{ active: activeSection === 'faq' }">FAQ</a>
        </nav>

        <div class="fig-actions-new">
          <a href="#" @click.prevent="handleSignupClick" class="fig-link-new desktop-only">Sign up</a>
          <a href="#" @click.prevent="showDemoModal = true" class="fig-btn-primary-new">Watch Demo</a>
        </div>
      </div>
    </header>

    <!-- Mobile Sidebar -->
    <div class="mobile-menu-overlay" :class="{ 'is-open': isMobileMenuOpen }" @click="isMobileMenuOpen = false"></div>
    <div class="mobile-sidebar" :class="{ 'is-open': isMobileMenuOpen }">
      <div class="mobile-sidebar-header">
        <img src="../assets/images/landing/figma/Makeping-Logo-Black.png" alt="MakePing" class="mobile-sidebar-logo" />
        <button class="mobile-close-btn" @click="isMobileMenuOpen = false" aria-label="Close Menu">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>
      <div class="mobile-sidebar-content">
        <a href="#features" @click.prevent="scrollToSection('features'); isMobileMenuOpen = false" class="mobile-sidebar-link">Features</a>
        <a href="#status-pages" @click.prevent="scrollToSection('status-pages'); isMobileMenuOpen = false" class="mobile-sidebar-link">Status Pages</a>
        <a href="#integrations" @click.prevent="scrollToSection('integrations'); isMobileMenuOpen = false" class="mobile-sidebar-link">Integrations</a>
        <a href="#pricing" @click.prevent="scrollToSection('pricing'); isMobileMenuOpen = false" class="mobile-sidebar-link">Pricing</a>
        <a href="#use-cases" @click.prevent="scrollToSection('use-cases'); isMobileMenuOpen = false" class="mobile-sidebar-link">Use Cases</a>
        <a href="#faq" @click.prevent="scrollToSection('faq'); isMobileMenuOpen = false" class="mobile-sidebar-link">FAQ</a>
        
        <div class="mobile-sidebar-divider"></div>
        
        <a href="#" @click.prevent="handleSignupClick(); isMobileMenuOpen = false" class="mobile-sidebar-link mobile-sidebar-signup">Sign up</a>
      </div>
    </div>



    <!-- Hero Section -->
    <section class="fig-hero-new">
      <div class="mesh-bg">
        <img src="../assets/images/landing/figma/hero-section-top-bg.png" class="bg-layer top-bg" />
        <img src="../assets/images/landing/figma/hero-section-middle-bg.png" class="bg-layer middle-bg" />
      </div>

      <div class="fig-hero-container-new">
        <div class="fig-hero-floating float-left-1">
          <img src="../assets/images/landing/figma/hero-section-api.svg" alt="API" class="hero-float-img api-img" />
        </div>
        
        <div class="fig-hero-floating float-left-2">
          <img src="../assets/images/landing/figma/hero-section-cursor.png" alt="Cursor" class="hero-cursor-img" />
          <div class="biz-badge">
            40k+ businesses worldwide
          </div>
        </div>
        
        <div class="fig-hero-floating float-right-1">
          <img src="../assets/images/landing/figma/hero-section-search.svg" alt="Search" class="hero-float-img search-img" />
        </div>

        <div class="fig-hero-content-center">
          <div class="fig-trust-badge">
            <div class="fig-trust-avatars">
              <div class="avatar av-1"></div>
              <div class="avatar av-2"></div>
              <div class="avatar av-3"></div>
            </div>
            <span class="fig-trust-text">Trusted by developers,<br/>agencies, and businesses</span>
          </div>

          <h1 class="fig-hero-title-new">
            Know when your website<br/>
            goes <span class="text-orange">down</span> before your users do.
          </h1>

          <p class="fig-hero-desc-new">
            MakePing helps you monitor websites, servers, APIs, SSL certificates, ports, cron jobs,<br/>
            keywords, page speed, and more with instant alerts and beautiful status pages.
          </p>

          <div class="fig-hero-buttons-new">
            <a href="#pricing" class="btn-view-pricing">View Pricing</a>
            <a href="#" @click.prevent="showDemoModal = true" class="btn-start-monitoring">
              <svg class="btn-play-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="11" stroke="#F84109" stroke-width="2"/>
                <path d="M10 8.5L15.5 12L10 15.5V8.5Z" fill="#F84109"/>
              </svg>
              Watch Demo
            </a>
          </div>
        </div>

        <div class="fig-hero-image-new glow-border-wrapper">
          <img src="../assets/images/landing/figma/hero-section-dashboard-preview.png" alt="Dashboard" />
        </div>
      </div>
    </section>

    <!-- Services Section -->
    <section id="features" class="fig-services-new">
      <div class="fig-container-new">
        <div class="fig-section-header-new">
          <span class="fig-section-label-new">Our Services</span>
          <h2 class="fig-section-title-new">Everything you need to monitor<br/>your website and services.</h2>
          <p class="fig-section-desc-new">MakePing gives you all essential monitoring tools in one simple platform built for<br/>website owners, developers, agencies, startups, and growing teams.</p>
        </div>

        <div class="fig-services-grid-new">
          <div class="fig-service-card-new">
            <div class="card-content">
              <h3 class="card-title">Website Monitoring</h3>
              <p class="card-desc">Be the first to know when your website is offline.</p>
            </div>
            <div class="card-illustration">
              <img src="../assets/images/landing/figma/website-monitoring.png" alt="Website Monitoring" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
              <div class="ill-fallback" style="display:none;"></div>
            </div>
          </div>
          <!-- SSL Monitoring -->
          <div class="fig-service-card-new">
            <div class="card-content">
              <h3 class="card-title">SSL Monitoring</h3>
              <p class="card-desc">Protect user trust and prevent security warning errors.</p>
            </div>
            <div class="card-illustration">
              <img src="../assets/images/landing/figma/ssl-monitoring.png" alt="SSL Monitoring" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
              <div class="ill-fallback" style="display:none;"></div>
            </div>
          </div>
          <!-- Ping Monitoring -->
          <div class="fig-service-card-new">
            <div class="card-content">
              <h3 class="card-title">Ping Monitoring</h3>
              <p class="card-desc">Know instantly when a server or device becomes unavailable.</p>
            </div>
            <div class="card-illustration">
              <img src="../assets/images/landing/figma/ping-monitoring.png" alt="Ping Monitoring" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
              <div class="ill-fallback" style="display:none;"></div>
            </div>
          </div>
          <!-- Port Monitoring -->
          <div class="fig-service-card-new">
            <div class="card-content">
              <h3 class="card-title">Port Monitoring</h3>
              <p class="card-desc">Detect service-level failures before they affect users.</p>
            </div>
            <div class="card-illustration">
              <img src="../assets/images/landing/figma/port-monitoring.png" alt="Port Monitoring" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
              <div class="ill-fallback" style="display:none;"></div>
            </div>
          </div>
          <!-- Heartbeat Monitoring -->
          <div class="fig-service-card-new">
            <div class="card-content">
              <h3 class="card-title">Heartbeat Monitoring</h3>
              <p class="card-desc">Never let silent background failures go unnoticed.</p>
            </div>
            <div class="card-illustration">
              <img src="../assets/images/landing/figma/heartbeat-monitoring.png" alt="Heartbeat Monitoring" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
              <div class="ill-fallback" style="display:none;"></div>
            </div>
          </div>
          <!-- Keyword Monitoring -->
          <div class="fig-service-card-new">
            <div class="card-content">
              <h3 class="card-title">Keyword Monitoring</h3>
              <p class="card-desc">Monitor not just uptime, but correct content.</p>
            </div>
            <div class="card-illustration">
              <img src="../assets/images/landing/figma/keyword-search-monitoring.png" alt="Keyword Monitoring" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
              <div class="ill-fallback" style="display:none;"></div>
            </div>
          </div>
          <!-- Page Load Monitoring -->
          <div class="fig-service-card-new">
            <div class="card-content">
              <h3 class="card-title">Page Load Monitoring</h3>
              <p class="card-desc">Improve speed, user experience, and conversion rates.</p>
            </div>
            <div class="card-illustration">
              <img src="../assets/images/landing/figma/page-load-monitoring.png" alt="Page Load Monitoring" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
              <div class="ill-fallback" style="display:none;"></div>
            </div>
          </div>
          <!-- Page Screenshot Monitoring -->
          <div class="fig-service-card-new">
            <div class="card-content">
              <h3 class="card-title">Page Screenshot Monitoring</h3>
              <p class="card-desc">See what users see, not just whether the site is online.</p>
            </div>
            <div class="card-illustration">
              <img src="../assets/images/landing/figma/page-ss-monitoring.png" alt="Page Screenshot Monitoring" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
              <div class="ill-fallback" style="display:none;"></div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Faded pink half-circle at the bottom -->
      <div class="fig-services-bg-curve"></div>
    </section>

    <!-- Status Pages Section -->
    <section id="status-pages" class="fig-status">
      <div class="fig-container">
        <div class="fig-status-grid">
          <div class="fig-status-content">
            <h2 class="fig-status-title">Keep users informed with<br/>branded status pages.</h2>
            <p class="fig-status-desc">Create clean, white-labeled status pages to share uptime, incidents,<br/>maintenance updates, and service health with your customers.</p>

            <div class="fig-features">
              <div class="fig-features-header">
                <div class="fig-features-line">
                  <span class="line-long"></span>
                  <span class="line-dot"></span>
                  <span class="line-dot"></span>
                </div>
                <h3 class="fig-features-title">FEATURE POINTS</h3>
              </div>
              <ul class="fig-features-list">
                <li>
                  <img src="../assets/images/landing/figma/solar-penbold.png" alt="Customize" class="feature-icon" />
                  Add your own logo and brand colours
                </li>
                <li>
                  <img src="../assets/images/landing/figma/majesticons_settings-cog-check.png" alt="Domain" class="feature-icon" />
                  Connect a custom domain
                </li>
                <li>
                  <img src="../assets/images/landing/figma/solar_document-bold.png" alt="Updates" class="feature-icon" />
                  Share incident and maintenance updates
                </li>
                <li>
                  <img src="../assets/images/landing/figma/solar-message-bold.png" alt="Email" class="feature-icon" />
                  Let subscribers receive email updates
                </li>
                <li>
                  <img src="../assets/images/landing/figma/lets-icons_check-fill.png" alt="Status" class="feature-icon" />
                  Display uptime and response status clearly
                </li>
              </ul>
            </div>

            <a href="#" @click.prevent="handleSignupClick" class="fig-cta-outline">Create Your Status Page</a>
          </div>
          <div class="fig-status-image">
            <div class="fig-status-composition">
              <img src="../assets/images/landing/figma/status-page-secton-bg.png" alt="Background" class="comp-bg" />
              <img src="../assets/images/landing/figma/status-page-secton-main.png" alt="Main UI" class="comp-main" />
              <img src="../assets/images/landing/figma/status-page-secton-create.png" alt="Create Dialog" class="comp-floating" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Integrations Section -->
    <section id="integrations" class="fig-integrations-new">
      <div class="fig-int-bg-wrapper">
        <!-- Using Group 32.png as the background image -->
        <img src="../assets/images/landing/figma/integrations-bg.png" alt="Integrations Background" class="fig-int-bg-img" />
      </div>
      
      <div class="fig-container" style="position: relative; z-index: 2;">
        <div class="fig-int-header">
          <h2 class="fig-int-title">Get alerts where<br/>your team already <span style="background: linear-gradient(90deg, #4A5568 0%, #A0AEC0 100%); background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent;">works</span></h2>
          <p class="fig-int-desc">When something breaks, MakePing notifies the right people through your<br/>preferred channels - so your team can act fast.</p>
          <a href="#" @click.prevent="handleSignupClick" class="fig-cta-outline" style="margin-top: 16px;">Connect Your Alert Channels</a>
        </div>

        <div class="fig-int-map" style="height: 650px;">
          <!-- Center Laptop Icon -->
          <div class="int-node int-center">
            <img src="../assets/images/landing/figma/makeping-bubble-logo-integrations-section.png" alt="Center Icon" style="width: 100%; height: auto; max-width: 220px;" />
          </div>
          
          <!-- Orbiting Nodes -->
          <div class="int-node int-bell">
            <div class="node-badge">
              <span>Notification</span>
              <img src="../assets/images/landing/figma/badge-arrow-icon.png" alt="Arrow" class="badge-arrow" />
            </div>
            <img src="../assets/images/landing/figma/mingcute_notification-fill.png" alt="Notification" style="width: 50px; height: auto;" />
          </div>
          <div class="int-node int-telegram">
            <div class="node-badge">
              <span>Telegram</span>
              <img src="../assets/images/landing/figma/badge-arrow-icon.png" alt="Arrow" class="badge-arrow" />
            </div>
            <img src="../assets/images/landing/figma/logos_telegram.png" alt="Telegram" style="width: 70px; height: auto;" />
          </div>
          <div class="int-node int-email">
            <div class="node-badge">
              <span>Email</span>
              <img src="../assets/images/landing/figma/badge-arrow-icon.png" alt="Arrow" class="badge-arrow" />
            </div>
            <img src="../assets/images/landing/figma/material-icon-theme_email.png" alt="Email" style="width: 45px; height: auto;" />
          </div>
          <div class="int-node int-teams">
            <div class="node-badge">
              <span>Teams</span>
              <img src="../assets/images/landing/figma/badge-arrow-icon.png" alt="Arrow" class="badge-arrow" />
            </div>
            <img src="../assets/images/landing/figma/logos_microsoft-teams.png" alt="Teams" style="width: 80px; height: auto;" />
          </div>
          <div class="int-node int-webhook">
            <div class="node-badge">
              <span>Webhook</span>
              <img src="../assets/images/landing/figma/badge-arrow-icon.png" alt="Arrow" class="badge-arrow" />
            </div>
            <img src="../assets/images/landing/figma/webhook-logo.png" alt="MakePing Webhook" style="width: 50px; height: auto;" />
          </div>
          <div class="int-node int-chat">
            <div class="node-badge">
              <span>Chat</span>
              <img src="../assets/images/landing/figma/badge-arrow-icon.png" alt="Arrow" class="badge-arrow" />
            </div>
            <img src="../assets/images/landing/figma/flat-color-icons_sms.png" alt="Chat" style="width: 50px; height: auto;" />
          </div>
          <div class="int-node int-phone">
            <div class="node-badge">
              <span>Phone</span>
              <img src="../assets/images/landing/figma/badge-arrow-icon.png" alt="Arrow" class="badge-arrow" />
            </div>
            <img src="../assets/images/landing/figma/streamline-flex-color_incoming-call-flat.png" alt="Phone" style="width: 50px; height: auto;" />
          </div>
          <div class="int-node int-slack">
            <div class="node-badge">
              <span>Slack</span>
              <img src="../assets/images/landing/figma/badge-arrow-icon.png" alt="Arrow" class="badge-arrow" />
            </div>
            <img src="../assets/images/landing/figma/logos_slack-icon.png" alt="Slack" style="width: 70px; height: auto;" />
          </div>
          <div class="int-node int-zapier">
            <div class="node-badge">
              <span>Zapier</span>
              <img src="../assets/images/landing/figma/badge-arrow-icon.png" alt="Arrow" class="badge-arrow" />
            </div>
            <img src="../assets/images/landing/figma/lineicons_zapier.png" alt="Zapier" style="width: 70px; height: auto;" />
          </div>
        </div>
      </div>
    </section>

    <!-- Use Cases Section -->
    <section id="use-cases" class="fig-status" style="overflow-x: hidden;">
      <div class="fig-container fig-status-grid">
        <!-- Left Content Column -->
        <div class="fig-status-content" style="gap: 20px;">
          <h2 class="fig-status-title" style="margin-bottom: 0;">Built for every team that<br/>depends on uptime.</h2>
          <p class="fig-status-desc" style="margin-bottom: 0;">Whether you manage a website, build apps, or support clients, MakePing helps you detect downtime, fix issues faster, and keep users informed.</p>

          <div class="use-cases-divider" style="display: flex; align-items: center; gap: 6px;">
            <div class="line" style="width: 40px; height: 3px; background-color: #FF5A2A; border-radius: 2px;"></div>
            <div class="dot" style="width: 4px; height: 4px; background-color: #FF5A2A; border-radius: 50%;"></div>
            <div class="dot" style="width: 4px; height: 4px; background-color: #FF5A2A; border-radius: 50%;"></div>
          </div>

          <div class="fig-use-tabs-wrapper" style="display: inline-flex; gap: 4px; border: 1px solid #E2E8F0; border-radius: 60px; padding: 6px; width: fit-content; margin-bottom: 0;">
            <button style="padding: 10px 24px; border-radius: 60px; border: 1px solid transparent; font-family: 'Inter', sans-serif; font-size: 15px; cursor: pointer; transition: all 0.3s ease;" :style="activeUseCaseTab === 'owners' ? 'background: linear-gradient(to bottom, rgba(248, 65, 9, 0.2) 0%, #FFFFFF 100%); border-color: rgba(248, 65, 9, 0.2); color: #1D2941; font-weight: 500;' : 'background: transparent; color: #4A5568;'" @click="activeUseCaseTab = 'owners'">Website Owners</button>
            <button style="padding: 10px 24px; border-radius: 60px; border: 1px solid transparent; font-family: 'Inter', sans-serif; font-size: 15px; cursor: pointer; transition: all 0.3s ease;" :style="activeUseCaseTab === 'devs' ? 'background: linear-gradient(to bottom, rgba(248, 65, 9, 0.2) 0%, #FFFFFF 100%); border-color: rgba(248, 65, 9, 0.2); color: #1D2941; font-weight: 500;' : 'background: transparent; color: #4A5568;'" @click="activeUseCaseTab = 'devs'">Web Developers</button>
            <button style="padding: 10px 24px; border-radius: 60px; border: 1px solid transparent; font-family: 'Inter', sans-serif; font-size: 15px; cursor: pointer; transition: all 0.3s ease;" :style="activeUseCaseTab === 'agencies' ? 'background: linear-gradient(to bottom, rgba(248, 65, 9, 0.2) 0%, #FFFFFF 100%); border-color: rgba(248, 65, 9, 0.2); color: #1D2941; font-weight: 500;' : 'background: transparent; color: #4A5568;'" @click="activeUseCaseTab = 'agencies'">Agencies</button>
          </div>

          <!-- Website Owners Content -->
          <div v-if="activeUseCaseTab === 'owners'" class="use-case-content" style="margin-bottom: 0;">
            <h3 class="fig-features-title" style="font-size: 20px; margin-bottom: 12px; color: #1D2941;">Website Owners</h3>
            <p class="fig-status-desc" style="margin-bottom: 12px;">Keep your website online and protect your visitors' trust.</p>
            <p class="fig-status-desc">MakePing monitors your website 24/7 and alerts you instantly when your site goes down, slows down, or faces SSL issues.</p>
          </div>

          <!-- Web Developers Content -->
          <div v-if="activeUseCaseTab === 'devs'" class="use-case-content" style="margin-bottom: 0;">
            <h3 class="fig-features-title" style="font-size: 20px; margin-bottom: 12px; color: #1D2941;">Web Developers</h3>
            <p class="fig-status-desc" style="margin-bottom: 12px;">Monitor websites, APIs, ports, and background jobs from one simple dashboard.</p>
            <p class="fig-status-desc">MakePing helps developers track uptime, APIs, cron jobs, ports, keywords, and page performance without complex setup.</p>
          </div>

          <!-- Agencies Content -->
          <div v-if="activeUseCaseTab === 'agencies'" class="use-case-content" style="margin-bottom: 0;">
            <h3 class="fig-features-title" style="font-size: 20px; margin-bottom: 12px; color: #1D2941;">Agencies</h3>
            <p class="fig-status-desc" style="margin-bottom: 12px;">Manage client websites with confidence and transparency.</p>
            <p class="fig-status-desc">MakePing helps agencies monitor multiple client websites and share branded status pages to keep clients informed during incidents.</p>
          </div>

          <div class="fig-features" style="margin-top: 0;">
            <div class="fig-features-header" style="margin-bottom: 16px;">
              <h3 class="fig-features-title" style="color: #1D2941;">Key Benefits:</h3>
            </div>
            
            <div class="fig-use-benefits-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
              <div class="fig-use-benefit-item" style="display: flex; align-items: center; gap: 12px; padding: 12px 16px; border: 1px solid #E2E8F0; border-radius: 8px; font-family: 'Inter', sans-serif; font-size: 14px; color: rgba(0,0,0,0.8); white-space: nowrap;">
                <img src="../assets/images/landing/figma/jam_alert-f.png" alt="Alert" style="width: 20px; height: 20px;" />
                Get instant downtime alerts
              </div>
              <div class="fig-use-benefit-item" style="display: flex; align-items: center; gap: 12px; padding: 12px 16px; border: 1px solid #E2E8F0; border-radius: 8px; font-family: 'Inter', sans-serif; font-size: 14px; color: rgba(0,0,0,0.8); white-space: nowrap;">
                <img src="../assets/images/landing/figma/mdi_timer-secure.png" alt="SSL" style="width: 20px; height: 20px;" />
                Monitor SSL expiry
              </div>
              <div class="fig-use-benefit-item" style="display: flex; align-items: center; gap: 12px; padding: 12px 16px; border: 1px solid #E2E8F0; border-radius: 8px; font-family: 'Inter', sans-serif; font-size: 14px; color: rgba(0,0,0,0.8); white-space: nowrap;">
                <img src="../assets/images/landing/figma/streamline-plump_browser-website-1-solid.png" alt="Track" style="width: 20px; height: 20px;" />
                Track website response time
              </div>
              <div class="fig-use-benefit-item" style="display: flex; align-items: center; gap: 12px; padding: 12px 16px; border: 1px solid #E2E8F0; border-radius: 8px; font-family: 'Inter', sans-serif; font-size: 14px; color: rgba(0,0,0,0.8); white-space: nowrap;">
                <img src="../assets/images/landing/figma/graph-icon-fill.png" alt="Avoid loss" style="width: 20px; height: 20px;" />
                Avoid losing leads, sales, and visitors
              </div>
            </div>
          </div>

          <a href="#" @click.prevent="handleSignupClick" class="fig-cta-outline">Monitor Your Website</a>
        </div>

        <!-- Right Image Column -->
        <div class="fig-status-image" style="position: relative; width: 100%; display: flex; align-items: center; justify-content: flex-end; margin-right: calc(min(50vw, 680px) - 50vw);">
          <!-- Inner container to lock original size -->
          <div style="position: relative; width: 100%; max-width: 570px;">
            <div class="glow-border-wrapper" style="border-radius: 24px 0 0 0; position: relative; z-index: 1; width: 100%; padding: 5px 0 0 5px; -webkit-mask-image: linear-gradient(to bottom, black 65%, transparent 100%); mask-image: linear-gradient(to bottom, black 65%, transparent 100%);">
              <img src="../assets/images/landing/figma/Status-Server Monitor-Report-Main.png" alt="MakePing Report Dashboard" style="border-radius: 12px 0 0 0; display: block;" />
            </div>
            <div class="use-float-1" style="position: absolute; top: 20%; left: -15%; width: 28%; z-index: 20;">
              <img src="../assets/images/landing/figma/Status-Server Monitor-Report-Up-1.svg" alt="Floating Stat" style="width: 100%; height: auto; border-radius: 16px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); display: block;" />
            </div>
            
            <div class="use-float-2" style="position: absolute; top: -8%; right: -16px; width: 45%; z-index: 20;">
              <img src="../assets/images/landing/figma/Status-Server Monitor-Report-Up-2.svg" alt="Floating Alert" style="width: 100%; height: auto; border-radius: 16px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); display: block;" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Pricing Section -->
    <section id="pricing" class="fig-pricing">
      <div class="fig-container">
        <div class="fig-pricing-box">
          <div class="fig-pricing-header">
            <h2 class="fig-pricing-title">Simple pricing for <span style="background: linear-gradient(95deg, #1D2941 64.99%, #F2F5F7 111.97%); background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent;">reliable</span><br/>monitoring.</h2>
            <p class="fig-pricing-desc">Choose a plan based on how many monitors your website, team, or business<br/>needs. Upgrade anytime as you grow.</p>
          </div>

          <div class="fig-pricing-grid">
            <article v-for="(plan, idx) in plans" :key="plan._id" class="fig-plan" :class="{ 'fig-plan-popular': selectedPlanIndex === idx }" @click="selectedPlanIndex = idx" style="cursor: pointer;">
              <div class="fig-plan-card">
                <div class="fig-plan-header" style="margin-bottom: 0;">
                  <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                    <h3 class="fig-plan-name">{{ plan.plan_name }}</h3>
                    <div v-if="idx === 1" class="fig-plan-badge">Most Popular</div>
                  </div>
                  <p class="fig-plan-desc">
                    <span v-if="idx === 0">Best for individuals and small websites</span>
                    <span v-else-if="idx === 1">Best for small teams and agencies</span>
                    <span v-else>Best for growing businesses</span>
                  </p>
                </div>

                <div class="fig-plan-price-box">
                  <span v-if="plan.offerPriceText" class="fig-plan-offer">{{ plan.offerPriceText }}</span>
                  <span v-if="plan.originalPriceText" class="fig-plan-original">{{ plan.originalPriceText }} / mo</span>
                </div>
                <p class="fig-plan-offer-text" v-if="plan.offerPriceText">Offer for 1st month</p>
                
                <div style="display: flex; align-items: center; gap: 4px; margin-top: -8px; margin-bottom: 24px;">
                  <div style="width: 32px; height: 3px; background-color: #1D2941; border-radius: 2px;"></div>
                  <div style="width: 4px; height: 4px; background-color: #1D2941; border-radius: 50%;"></div>
                  <div style="width: 4px; height: 4px; background-color: #1D2941; border-radius: 50%;"></div>
                </div>

                <ul class="fig-plan-features" style="margin-bottom: 24px;">
                  <li>{{ plan.monitorCountText || '50' }} monitors</li>
                  <li>{{ plan.alertTypesText || '7' }} integrations</li>
                  <li>60-second monitoring interval</li>
                  <li>HTTP, port, and ping monitoring</li>
                  <li>Heartbeat monitoring</li>
                  <li>Keyword monitoring</li>
                  <li>SSL monitoring</li>
                  <li>Full-featured status pages</li>
                </ul>

                <div style="height: 1px; width: 100%; opacity: 0.1; background: #1D2941; margin-bottom: 24px;"></div>

                <button class="fig-plan-cta" type="button" @click="openModalForPlan(idx)">
                  Start Monitoring
                </button>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <!-- Reviews Section -->
    <section id="reviews" class="fig-reviews">
      <div class="fig-container">
        <div class="fig-reviews-header">
          <div class="fig-reviews-title-area">
            <span class="fig-reviews-tag">Customer Stories</span>
            <h2 class="fig-reviews-title">Loved by website owners,<br/>developers, and growing <span class="text-slate">teams.</span></h2>
          </div>
          <div class="fig-reviews-nav">
            <button class="fig-nav-btn fig-nav-prev"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>
            <button class="fig-nav-btn fig-nav-next"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>
          </div>
        </div>

        <div class="fig-reviews-grid">
          <!-- Card 1 -->
          <div class="fig-review-card">
            <img src="../assets/images/landing/figma/review-section-quotes.png" alt="Quote" class="review-quote-icon" />
            <p class="review-text">MakePing helps us detect website downtime quickly, notify the right people, and keep our customers informed with a simple status page.</p>
            <div class="review-author">
              <h4>Emily R.</h4>
              <p>Online Store Owner</p>
            </div>
          </div>
          <!-- Card 2 -->
          <div class="fig-review-card">
            <img src="../assets/images/landing/figma/review-section-quotes.png" alt="Quote" class="review-quote-icon" />
            <p class="review-text">MakePing gives us a clear view of website performance and alerts. It is simple, affordable, and easy for our team to manage.</p>
            <div class="review-author">
              <h4>Sarah M.</h4>
              <p>SaaS Operations Manager</p>
            </div>
          </div>
          <!-- Card 3 -->
          <div class="fig-review-card">
            <img src="../assets/images/landing/figma/review-section-quotes.png" alt="Quote" class="review-quote-icon" />
            <p class="review-text">Setting up uptime, SSL, and cron job monitoring was simple. We now know about issues before our users report them.</p>
            <div class="review-author">
              <h4>David K.</h4>
              <p>Web Developer</p>
            </div>
          </div>
          <!-- Card 4 -->
          <div class="fig-review-card">
            <img src="../assets/images/landing/figma/review-section-quotes.png" alt="Quote" class="review-quote-icon" />
            <p class="review-text">MakePing helps us detect website downtime quickly, notify the right people, and keep our customers informed with a simple status page.</p>
            <div class="review-author">
              <h4>Emily R.</h4>
              <p>Online Store Owner</p>
            </div>
          </div>
          <!-- Card 5 -->
          <div class="fig-review-card">
            <img src="../assets/images/landing/figma/review-section-quotes.png" alt="Quote" class="review-quote-icon" />
            <p class="review-text">MakePing gives us a clear view of website performance and alerts. It is simple, affordable, and easy for our team to manage.</p>
            <div class="review-author">
              <h4>Sarah M.</h4>
              <p>SaaS Operations Manager</p>
            </div>
          </div>
          <!-- Card 6 -->
          <div class="fig-review-card">
            <img src="../assets/images/landing/figma/review-section-quotes.png" alt="Quote" class="review-quote-icon" />
            <p class="review-text">Setting up uptime, SSL, and cron job monitoring was simple. We now know about issues before our users report them.</p>
            <div class="review-author">
              <h4>David K.</h4>
              <p>Web Developer</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Section -->
    <section id="faq" class="fig-faq">
      <div class="fig-container fig-faq-layout">
        <!-- Left Sidebar -->
        <div class="fig-faq-sidebar">
          <h2 class="fig-faq-title">Frequently <span class="fig-faq-gradient-text">Asked</span><br/>Questions</h2>
          <div class="use-cases-divider" style="margin: 20px 0;">
            <div class="line" style="width: 25px;"></div><div class="dot"></div><div class="dot"></div>
          </div>

          <div class="fig-faq-card">
            <h4>Still have questions?</h4>
            <p>Can't find the answer you're looking for? Please chat to our friendly team.</p>
            <a href="mailto:support@makeping.com" class="fig-faq-contact-btn">Contact Us</a>
          </div>
        </div>

        <!-- Right Accordion -->
        <div class="fig-faq-accordion">
          <div v-for="(faq, index) in faqList" :key="index" class="fig-faq-item" :class="{ 'fig-faq-active': activeFaq === index }">
            <button class="fig-faq-question" @click="toggleFaq(index)">
              <span>{{ faq.q }}</span>
              <span class="fig-faq-icon"></span>
            </button>
            <div class="fig-faq-answer" v-show="activeFaq === index">
              <p>{{ faq.a }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Bottom Hero Section -->
    <section class="fig-bottom-hero">
      <div class="fig-bh-bg">
        <img src="../assets/images/landing/figma/bottom-hero-section-bg.png" alt="" class="fig-bh-bg-img" />
      </div>

      <div class="fig-bh-content">
        <h2 class="fig-bh-title">Start <span style="color: #F84109;">monitoring</span> your website <span class="fig-bh-gradient-text">before</span><br/>the next outage <span class="fig-bh-gradient-text">happens.</span></h2>
        <p class="fig-bh-desc">Protect your uptime, improve response time, notify your team instantly,<br/>and keep your users informed with MakePing.</p>

        <div class="fig-bh-buttons">
          <a href="mailto:support@makeping.com" class="fig-bh-btn fig-bh-btn-secondary">Contact Us</a>
          <a href="#" @click.prevent="openModalForPlan(0)" class="fig-bh-btn fig-bh-btn-primary">Start with $0.95</a>
        </div>
      </div>

      <div class="fig-bh-grade-container">
        <img src="../assets/images/landing/figma/bottom-hero-section-grade.png" alt="" class="fig-bh-grade-img" />
      </div>

      <div class="fig-bh-faded">
        <div class="marquee-track">
          <h1 class="fig-bh-faded-text">Simple setup. Affordable plans. Instant alerts. Full-featured status pages.</h1>
          <h1 class="fig-bh-faded-text">Simple setup. Affordable plans. Instant alerts. Full-featured status pages.</h1>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="fig-footer">
      <div class="fig-container fig-footer-content">
        <div class="fig-footer-bottom">
          <p class="fig-footer-copyright">© 2026 Makeping. All rights reserved.</p>
          <div class="fig-footer-legal-links">
            <a href="#" @click.prevent="openPolicyModal('privacy')" class="fig-footer-link">Privacy Policy</a>
            <a href="#" @click.prevent="openPolicyModal('terms')" class="fig-footer-link">Terms of Service</a>
            <a href="#" @click.prevent="openPolicyModal('refund')" class="fig-footer-link">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import SubscribeModal from './SubscribeModal.vue';
import PolicyModal from './PolicyModal.vue';
import VideoModal from './VideoModal.vue';
import UserService from "./../../services/userController";

export default {
  name: "subscribe",
  components: { SubscribeModal, PolicyModal, VideoModal },
  data() {
    return {
      isMobileMenuOpen: false,
      activeSection: 'features',
      isScrolled: false,
      email: "",
      loading: false,
      plans: [],
      selectedPlanIndex: 0,
      showModal: false,
      showPolicyModal: false,
      showDemoModal: false,
      policyType: 'privacy',
      monitor_type_opt: {
        1: "HTTP(s)",
        2: "Keyword",
        3: "Ping",
        4: "Port",
        5: "Heartbeat",
        6: "Page Speed",
        7: "Page Screenshot",
      },
      alert_opt: {
        1: "Email",
        3: "Telegram",
        4: "Web push",
        5: "Webhook",
        6: "Message",
        7: "Call",
        8: "Slack",
        9: "Zappier webhook",
        10: "Zulip",
        11: "Teams",
      },
      offerEndsIn: 0,
      timerInterval: null,
      emailInputHighlight: false,
      showModal: false,
      windowWidth: 0,
      activeUseCaseTab: 'owners',
      activeFaq: null,
      faqList: [
        { q: "What is MakePing?", a: "MakePing is an uptime monitoring service that helps you detect website downtime, fix issues fast, and keep your users happy." },
        { q: "How often does MakePing check my website?", a: "Depending on your plan, MakePing checks your website as frequently as every 60 seconds." },
        { q: "What can I monitor with MakePing?", a: "You can monitor HTTP/HTTPS, SSL certificates, ports, pings, keywords, and cron jobs." },
        { q: "How will I receive alerts?", a: "We support alerts via Email, Slack, Teams, Telegram, Webhooks, SMS, and Voice Calls." },
        { q: "Can I create a status page?", a: "Yes, you can easily create and host full-featured status pages to keep your users informed." },
        { q: "Can I use my own branding on the status page?", a: "Yes, our status pages are fully customizable with your own branding and custom domain." },
        { q: "Who should use MakePing?", a: "Website owners, web developers, agencies, and SaaS teams who want to ensure maximum uptime." },
        { q: "Does MakePing support cron job monitoring?", a: "Yes, we support cron job / heartbeat monitoring to ensure your background tasks run successfully." }
      ],
    };
  },
  mounted() {
    this.getPlanList();
    this.initializeOfferTimer();
    this.startOfferTimer();
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('storage', this.handleStorageChange);
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    this.showModal = true;
  },
  beforeDestroy() {
    if (this.timerInterval) clearInterval(this.timerInterval);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('storage', this.handleStorageChange);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 20;

      const sections = ['features', 'status-pages', 'integrations', 'pricing', 'use-cases', 'faq'];
      let currentSection = this.activeSection;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= window.innerHeight / 3 && rect.bottom >= window.innerHeight / 3) {
            currentSection = section;
            break;
          }
        }
      }
      this.activeSection = currentSection;
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        
        this.activeSection = id;
      }
    },
    openModalForPlan(idx) {
      if (typeof idx === 'number') {
        this.selectedPlanIndex = idx;
      } else {
        this.selectedPlanIndex = 0;
      }
      this.showModal = true;
    },
    toggleFaq(index) {
      if (this.activeFaq === index) {
        this.activeFaq = null;
      } else {
        this.activeFaq = index;
      }
    },
    initializeOfferTimer() {
      const storedEndTime = localStorage.getItem('makepingOfferEndTime');
      if (!storedEndTime) {
        const endTime = Date.now() + (5 * 24 * 60 * 60 * 1000);
        localStorage.setItem('makepingOfferEndTime', endTime.toString());
        this.calculateRemainingTime(endTime);
      } else {
        this.calculateRemainingTime(parseInt(storedEndTime));
      }
    },
    calculateRemainingTime(endTime) {
      const now = Date.now();
      const remaining = Math.floor((endTime - now) / 1000);
      if (remaining <= 0) {
        const newEndTime = Date.now() + (5 * 24 * 60 * 60 * 1000);
        localStorage.setItem('makepingOfferEndTime', newEndTime.toString());
        this.offerEndsIn = 432000;
      } else {
        this.offerEndsIn = remaining;
      }
    },
    handleStorageChange(e) {
      if (e.key === 'makepingOfferEndTime' && e.newValue) {
        this.calculateRemainingTime(parseInt(e.newValue));
      }
    },
    async getPlanList() {
      try {
        const allMonitorTypes = Object.keys(this.monitor_type_opt).map(Number);
        let allAlertTypes = Object.keys(this.alert_opt).map(Number);
        if (!allAlertTypes.includes(2)) {
          allAlertTypes.push(2);
          allAlertTypes.sort((a, b) => a - b);
        }
        const response = await UserService.getPlanList();
        if (response.result && Array.isArray(response.data)) {
          this.plans = response.data
            .filter(plan => plan.status === undefined || plan.status === true)
            .map(plan => {
              let discountPrice = 0;
              if (plan.discountType == 'fixed') {
                discountPrice = plan.discountValue || 0;
              } else if (plan.discountType == 'percentage') {
                discountPrice = (plan.price || 0) * ((plan.discountValue || 0) / 100);
              }
              discountPrice = Math.round((discountPrice + Number.EPSILON) * 100) / 100;
              const offerPrice = (plan.price || 0) - discountPrice;
              let includedMonitorTypes = Array.isArray(plan.monitorTypes) ? plan.monitorTypes : [];
              let excludedMonitorTypes = allMonitorTypes.filter(type => !includedMonitorTypes.includes(type));
              let monitorTypesText = 'All';
              if (includedMonitorTypes.length === allMonitorTypes.length) {
                monitorTypesText = 'All';
              } else if (includedMonitorTypes.length > 0) {
                monitorTypesText = includedMonitorTypes.map(type => this.monitor_type_opt[type] || type).join(', ');
              } else {
                monitorTypesText = '-';
              }
              let includedAlertTypes = Array.isArray(plan.alertsTypes) ? plan.alertsTypes : [];
              includedAlertTypes = includedAlertTypes.filter(type => type != 2);
              let excludedAlertTypes = allAlertTypes.filter(type => !includedAlertTypes.includes(type));
              let alertTypesText = 'All';
              if (includedAlertTypes.length === allAlertTypes.length) {
                alertTypesText = 'All';
              } else if (includedAlertTypes.length > 0) {
                alertTypesText = includedAlertTypes
                  .filter(type => type != 2)
                  .map(type => this.alert_opt[type] || type)
                  .join(', ');
              } else {
                alertTypesText = '-';
              }
              let intervalText = `${plan.minIntervalLimit ? plan.minIntervalLimit : 1} min`;
              let monitorCountText = plan.monitorcount !== undefined ? plan.monitorcount : '-';
              let subUserText = plan.subUserLimit !== undefined ? plan.subUserLimit : '-';
              let offerPriceText = (discountPrice > 0 && offerPrice > 0)
                ? `$${offerPrice.toFixed(2)}`
                : (plan.price ? `$${Number(plan.price).toFixed(2)}` : '-');
              let originalPriceText = (discountPrice > 0 && plan.price)
                ? `$${Number(plan.price).toFixed(2)}`
                : '';
              return {
                ...plan,
                monitorTypesText,
                alertTypesText,
                offerPriceText,
                originalPriceText,
                intervalText,
                monitorCountText,
                subUserText,
              };
            });
          const planOrder = ['silver', 'gold', 'platinum'];
          this.plans = this.plans.sort((a, b) => {
            const aIdx = planOrder.indexOf((a.plan_name || '').toLowerCase());
            const bIdx = planOrder.indexOf((b.plan_name || '').toLowerCase());
            return aIdx - bIdx;
          });
          const goldIndex = this.plans.findIndex(p => p.plan_name && p.plan_name.toLowerCase() == 'gold');
          this.selectedPlanIndex = goldIndex != -1 ? goldIndex : 0;
        }
      } catch (e) {
        console.log("Error in getting plan list");
        console.log(e);
      }
    },
    async handleSubscribe(planIdx) {
      if (typeof planIdx === 'number' && planIdx !== this.selectedPlanIndex) {
        this.selectedPlanIndex = planIdx;
      }
      if (!this.email) {
        this.$nextTick(() => {
          const input = this.$refs.emailInput;
          if (input) {
            const el = input instanceof HTMLElement ? input : (input.$el || input);
            if (el && typeof el.focus === 'function') el.focus();
            if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.emailInputHighlight = true;
            setTimeout(() => { this.emailInputHighlight = false; }, 800);
          }
        });
        return;
      }
      try {
        this.loading = true;
        const idx = typeof planIdx === 'number' ? planIdx : this.selectedPlanIndex;
        const planId = this.plans[idx]._id;
        const response = await UserService.subscribe(planId, this.email);
        if (response.result) {
          this.$toasted.show("Email validated successfully!", {
            theme: "outline",
            position: "bottom-center",
            type: "success",
            duration: 3000
          });
          this.showModal = false;
          window.location.href = response.data;
        } else {
          this.$toasted.show(response.message, {
            theme: "outline",
            position: "bottom-center",
            type: "error",
            duration: 2000
          });
        }
      } catch (error) {
        console.error("Error during subscription:", error);
        this.$toasted.show("An error occurred. Please try again.", {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000
        });
      } finally {
        this.loading = false;
      }
    },
    startOfferTimer() {
      this.timerInterval = setInterval(() => {
        const storedEndTime = localStorage.getItem('makepingOfferEndTime');
        if (storedEndTime) {
          this.calculateRemainingTime(parseInt(storedEndTime));
        } else {
          this.initializeOfferTimer();
        }
      }, 1000);
    },
    onModalPlanSelect(idx) {
      this.selectedPlanIndex = idx;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    handleLoginClick() {
      const goldIndex = this.plans.findIndex(p => p.plan_name && p.plan_name.toLowerCase() === 'gold');
      this.selectedPlanIndex = goldIndex !== -1 ? goldIndex : 1;
      this.showModal = true;
    },
    handleSignupClick() {
      const goldIndex = this.plans.findIndex(p => p.plan_name && p.plan_name.toLowerCase() === 'gold');
      this.selectedPlanIndex = goldIndex !== -1 ? goldIndex : 1;
      this.showModal = true;
    },
    openPolicyModal(type) {
      this.policyType = type;
      this.showPolicyModal = true;
    },
    refreshPage() {
      window.location.reload();
    },
  },
  computed: {
    formattedOfferEndsIn() {
      let t = this.offerEndsIn;
      const days = Math.floor(t / 86400);
      t %= 86400;
      const hours = Math.floor(t / 3600);
      t %= 3600;
      const minutes = Math.floor(t / 60);
      const seconds = t % 60;
      return {
        days: days,
        hours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0'),
        seconds: seconds.toString().padStart(2, '0'),
      };
    },
    isMobile() {
      return this.windowWidth <= 768;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Mulish:wght@400;500;600;700;800&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.figma-landing {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  font-family: 'Inter', sans-serif;
  color: #1D2941;
}

.figma-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 40px;
}

.fig-container {
  max-width: 1360px;
  margin: 0 auto;
  width: 100%;
}

/* ===== HEADER ===== */
.fig-header-new {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: transparent;
  padding-top: 24px;
  padding-bottom: 24px;
  transition: all 0.3s ease;
}

.fig-header-new.scrolled {
  padding-top: 16px;
  padding-bottom: 16px;
  background: rgba(255, 255, 255, 0.30);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
}

.fig-header-inner-new {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.fig-logo-new {
  display: flex;
  text-decoration: none;
}

.fig-logo-img-new {
  height: 52px;
  width: auto;
}

.fig-nav-new {
  display: flex;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 60px;
  border: 1px solid rgba(29, 41, 65, 0.10);
  background: radial-gradient(124.43% 90.61% at 50.09% 100%, rgba(248, 65, 9, 0.05) 34.39%, rgba(255, 255, 255, 0.00) 100%);
}

.fig-nav-link-new {
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.8);
  text-decoration: none;
  border-radius: 24px;
  border: 1px solid rgba(248, 65, 9, 0);
  border-bottom: none;
  transition: all 0.2s;
}

.fig-nav-link-new.active, .fig-nav-link-new:hover {
  border: 1px solid rgba(248, 65, 9, 0.10);
  border-bottom: none;
  background: linear-gradient(180deg, rgba(248, 65, 9, 0.30) 0%, rgba(255, 255, 255, 0.50) 100%);
  color: rgba(0, 0, 0, 1);
  box-shadow: none;
}

.fig-actions-new {
  display: flex;
  align-items: center;
  gap: 12px;
}

.fig-link-new {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  text-decoration: none;
  padding: 0 24px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: transparent;
  transition: all 0.2s;
}

.fig-link-new:hover {
  background: rgba(0, 0, 0, 0.03);
}

.fig-btn-primary-new {
  padding: 0 24px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  background: linear-gradient(180deg, #FFEBE4 0%, #FFBCA4 100%);
  border: 1px solid #FF8D70;
  text-decoration: none;
  border-radius: 30px;
  transition: all 0.2s;
}

.fig-btn-primary-new:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.8) 0%, transparent 80%), radial-gradient(172.26% 118.18% at 50% 100%, rgba(248, 65, 9, 0.70) 0%, rgba(255, 255, 255, 0.05) 100%), #FFFFFF;
}

/* ===== MOBILE SIDEBAR ===== */
.mobile-menu-btn {
  display: none;
  background: transparent;
  border: none;
  color: #1D2941;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
}
.mobile-menu-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

.mobile-menu-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  z-index: 9998;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}
.mobile-menu-overlay.is-open {
  opacity: 1;
  visibility: visible;
}

.mobile-sidebar {
  position: fixed;
  top: 0; left: -300px;
  width: 280px;
  height: 100vh;
  background: #ffffff;
  z-index: 9999;
  box-shadow: 5px 0 20px rgba(0,0,0,0.1);
  transition: left 0.3s ease;
  display: flex;
  flex-direction: column;
}
.mobile-sidebar.is-open {
  left: 0;
}

.mobile-sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
}
.mobile-sidebar-logo {
  height: 24px;
}
.mobile-close-btn {
  background: transparent;
  border: none;
  color: #1D2941;
  cursor: pointer;
  padding: 4px;
}

.mobile-sidebar-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.mobile-sidebar-link {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #1D2941;
  text-decoration: none;
}
.mobile-sidebar-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 8px 0;
}
.mobile-sidebar-signup {
  color: #F84109;
  font-weight: 600;
}

/* ===== HERO ===== */
.fig-hero-new {
  position: relative;
  padding: 180px 20px 0;
  background: #ffffff;
  overflow: hidden;
  text-align: center;
}

.fig-hero-new::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 250px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #ffffff 80%, #ffffff 100%);
  z-index: 20;
  pointer-events: none;
}

.mesh-bg {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
}
.bg-layer {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.8;
}
.top-bg {
  top: 0; left: 0;
}
.middle-bg {
  top: 25%; left: 0;
}
.api-img { width: 140px; height: auto; }
.search-img { width: 220px; height: auto; }
.hero-cursor-img {
  position: absolute;
  top: -20px;
  right: -10px;
  width: 32px;
  height: auto;
  z-index: 2;
}

.fig-hero-container-new {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
}

.fig-hero-floating {
  position: absolute;
  z-index: 2;
  pointer-events: none;
}
.float-left-1 {
  top: 80px;
  left: 20px;
  animation: float-up-down 6s ease-in-out infinite;
}
.float-left-2 {
  top: 340px;
  left: -20px;
  animation: float-up-down 7s ease-in-out infinite 1s;
}
.float-right-1 {
  top: 180px;
  right: -10px;
  animation: float-up-down 8s ease-in-out infinite 2s;
}

@keyframes float-up-down {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
}

.biz-badge {
  background: rgba(29, 41, 65, 0.02);
  border: 1px solid rgba(29, 41, 65, 0.10);
  border-radius: 60px;
  padding: 8px 16px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.60);
  line-height: 26px;
  display: flex;
  align-items: center;
}

.fig-hero-content-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 80px;
}

.fig-trust-badge {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  padding: 12px 16px 12px 10px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 60px;
  border: 1px solid rgba(29, 41, 65, 0.60);
  background: radial-gradient(150.03% 114.23% at 50.19% 125.37%, #1D2941 60%, #4A566E 100%);
  margin-bottom: 40px;
}

.fig-trust-badge::before {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 15px;
  border-radius: 200px;
  background: rgba(248, 65, 9, 0.7);
  filter: blur(12px);
  z-index: 0;
}
.fig-trust-avatars {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #FFFFFF;
  margin-right: -10px;
  background-size: cover;
  background-position: center;
}
.avatar.av-1 { background-color: #E2E2E2; background-image: url('../assets/images/landing/figma/trusted-devs-1.png'); }
.avatar.av-2 { background-color: #CFCFCF; background-image: url('../assets/images/landing/figma/trusted-devs-2.png'); }
.avatar.av-3 { background-color: #BFBFBF; background-image: url('../assets/images/landing/figma/trusted-devs-3.png'); margin-right: 0;}

.fig-trust-text {
  position: relative;
  z-index: 1;
  color: #FFFFFF;
  font-size: 13px;
  line-height: 1.4;
  text-align: left;
  font-weight: 500;
}

.fig-hero-title-new {
  font-family: 'Mulish', sans-serif;
  font-size: 65px;
  font-weight: 400;
  color: #1D2941;
  line-height: 70px;
  margin-bottom: 24px;
  letter-spacing: -2.6px;
}
.text-orange {
  color: #F84109;
  font-weight: 600;
}

.fig-hero-desc-new {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.80);
  line-height: 26px;
  margin-bottom: 32px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.fig-hero-buttons-new {
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: center;
}

.btn-view-pricing {
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #000000;
  background: #fff;
  border: 1px solid rgba(29, 41, 65, 0.15);
  border-radius: 60px;
  text-decoration: none;
  transition: all 0.2s;
  box-shadow: 0 4px 15px rgba(0,0,0,0.03);
}
.btn-view-pricing:hover {
  background: #F7FAFC;
  border-color: rgba(29, 41, 65, 0.25);
}

.btn-start-monitoring {
  display: flex;
  gap: 8px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #000000;
  border: 1px solid rgba(248, 65, 9, 0.80);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7) 0%, transparent 80%), radial-gradient(172.26% 118.18% at 50% 100%, rgba(248, 65, 9, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%), #FFFFFF;
  border-radius: 60px;
  text-decoration: none;
  transition: all 0.2s;
}
.btn-play-icon {
  flex-shrink: 0;
}
.btn-start-monitoring:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.8) 0%, transparent 80%), radial-gradient(172.26% 118.18% at 50% 100%, rgba(248, 65, 9, 0.30) 0%, rgba(255, 255, 255, 0.05) 100%), #FFFFFF;
}

/* Reusable Glow Border */
.glow-border-wrapper {
  position: relative;
  overflow: hidden;
  padding: 5px;
  background: #111827;
}
.glow-border-wrapper::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(
    from 0deg,
    rgba(248, 65, 9, 1) 0%,
    transparent 15%,
    transparent 35%,
    rgba(248, 65, 9, 1) 50%,
    transparent 65%,
    transparent 85%,
    rgba(248, 65, 9, 1) 100%
  );
  filter: blur(25px);
  animation: rotate-glow 15s linear infinite;
  z-index: 0;
}
.glow-border-wrapper > img {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: auto;
}

.fig-hero-image-new {
  max-width: 900px;
  margin: 0 auto;
  border-radius: 20px 20px 0 0;
  z-index: 10;
}
.fig-hero-image-new img {
  border-radius: 15px 15px 0 0;
}

@keyframes rotate-glow {
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 1024px) {
  .fig-hero-floating {
    display: none;
  }
  .fig-hero-title-new {
    font-size: 60px;
  }
}
@media (max-width: 768px) {
  .desktop-only { display: none !important; }
  .mobile-menu-btn { display: flex; }
  
  .fig-header-inner-new {
    flex-direction: row;
    padding: 6px 12px;
  }
  .fig-btn-primary-new {
    height: 36px;
    padding: 0 16px;
    font-size: 13px;
  }
  .fig-hero-title-new {
    font-size: 40px;
  }
  .fig-hero-desc-new {
    font-size: 16px;
  }
  .fig-nav-new {
    display: none;
  }
}

/* ===== SERVICES ===== */
.fig-services-new {
  padding: 60px 20px 0;
  background: #ffffff;
  position: relative;
  overflow: hidden;
}
.fig-services-bg-curve {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 150%;
  height: 200px;
  background: linear-gradient(to top, rgba(255, 240, 235, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: 0 0 50% 50% / 0 0 100% 100%;
  z-index: 0;
  pointer-events: none;
}
.fig-container-new {
  max-width: 1260px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  padding-bottom: 80px;
}
.fig-section-header-new {
  text-align: center;
  margin-bottom: 60px;
}
.fig-section-label-new {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 4px 16px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.80);
  background: radial-gradient(124.43% 90.61% at 50.09% 100%, rgba(248, 65, 9, 0.05) 34.39%, rgba(255, 255, 255, 0.00) 100%);
  border: 1px solid rgba(29, 41, 65, 0.10);
  border-radius: 60px;
  margin-bottom: 24px;
}
.fig-section-title-new {
  text-align: center;
  font-family: 'Mulish', sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 50px;
  letter-spacing: -1.6px;
  background: linear-gradient(95deg, #1D2941 64.99%, #F2F5F7 111.97%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 16px;
}
.text-muted {
  color: #4A5568;
  font-weight: 500;
}
.fig-section-desc-new {
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.80);
}
.fig-services-grid-new {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
.fig-service-card-new {
  width: 100%;
  max-width: 295px;
  height: 260.5px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  padding: 0;
  border-radius: 28px;
  border: 1px solid rgba(248, 65, 9, 0.20);
  background: radial-gradient(141.72% 90.61% at 50.09% 100%, rgba(255, 255, 255, 0.00) 0%, rgba(248, 65, 9, 0.04) 100%);
  overflow: hidden;
  transition: all 0.2s;
}
.fig-service-card-new:hover {
  box-shadow: 0 10px 30px rgba(255, 122, 80, 0.08);
  transform: translateY(-4px);
  border-color: rgba(248, 65, 9, 0.40);
}
.card-content {
  padding: 15px 15px 0 15px;
  margin: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
  z-index: 1;
}
.card-title {
  font-family: 'Mulish', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.80);
  line-height: 32px;
  letter-spacing: -0.8px;
  margin: 0;
}
.card-desc {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.80);
  line-height: 26px;
  margin: 0;
}
.card-illustration {
  margin-top: -35px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
}
.card-illustration img {
  max-width: 100%;
  height: auto;
  display: block;
  filter: drop-shadow(0 -10px 50px rgba(248, 65, 9, 0.30));
  margin-bottom: 0;
}
.ill-fallback {
  width: 100%;
  height: 140px;
  background-color: transparent;
}
@media (max-width: 1024px) {
  .fig-services-grid-new {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .fig-services-grid-new {
    grid-template-columns: 1fr;
  }
  .fig-section-title-new {
    font-size: 32px;
  }
}

/* ===== STATUS PAGES ===== */
.fig-status {
  padding: 0px 56px 40px 40px;
  background: #ffffff;
}

#status-pages {
  padding-top: 100px;
}

.fig-status-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.fig-status-image {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.fig-status-composition {
  position: relative;
  width: 100%;
  max-width: 480px;
}

.comp-bg {
  width: 100%;
  aspect-ratio: 1 / 1;
  display: block;
  transform: rotate(90deg) scale(1.0);
  position: relative;
  z-index: 1;
  pointer-events: none;
}

.comp-main {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 88%;
  height: auto;
  z-index: 0;
  border-bottom-right-radius: 26px;
}

.comp-floating {
  position: absolute;
  top: 10%;
  left: -28%;
  width: 65%;
  height: auto;
  z-index: 2;
  animation: floatStatusCreate 4s ease-in-out infinite;
}

.use-float-1 {
  animation: floatStatusCreate 5s ease-in-out infinite;
}

.use-float-2 {
  animation: floatStatusHorizontal 4s ease-in-out infinite;
}

@keyframes floatStatusCreate {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}

@keyframes floatStatusHorizontal {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(-15px); }
}

.fig-status-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-left: 40px;
}

.fig-status-title {
  font-family: 'Mulish', sans-serif;
  font-size: 36px;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: -1.6px;
  background: linear-gradient(95deg, #1D2941 64.99%, #F2F5F7 111.97%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 12px;
}

.fig-status-desc {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.80);
  line-height: 24px;
}

.fig-features {
  padding: 0;
  background: transparent;
  border-radius: 0;
  margin-top: 12px;
}

.fig-features-header {
  margin-bottom: 0;
}

.fig-features-title {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.80);
  margin-bottom: 28px;
}

.fig-features-line {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 28px;
}

.line-long {
  width: 44px;
  height: 3px;
  background-color: #FF5A2A;
  border-radius: 2px;
}

.line-dot {
  width: 4px;
  height: 4px;
  background-color: #FF5A2A;
  border-radius: 50%;
}

.fig-features-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.fig-features-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.80);
  padding: 0;
}

.feature-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: block;
}

.fig-cta-outline {
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 30px;
  font-family: 'Inter', sans-serif;
  font-size: 22px;
  font-weight: 400;
  color: #000000;
  background-color: #FFFFFF;
  background-image: radial-gradient(172.26% 118.18% at 50% 100%, rgba(248, 65, 9, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%);
  border: 1px solid rgba(248, 65, 9, 0.80);
  border-radius: 60px;
  text-decoration: none;
  transition: all 0.2s;
  margin-top: 8px;
  width: fit-content;
}

.fig-cta-outline:hover {
  box-shadow: 0 6px 15px rgba(255, 122, 80, 0.25);
  transform: translateY(-1px);
}

.fig-cta {
  display: inline-block;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  background: #1D2941;
  text-decoration: none;
  border-radius: 8px;
  transition: background 0.2s;
}

.fig-cta:hover {
  background: #0f1a2a;
}

/* ===== INTEGRATIONS ===== */
.fig-integrations-new {
  position: relative;
  padding: 100px 40px 0 40px;
  background: #ffffff;
  text-align: center;
  overflow: hidden;
}

.fig-int-bg-wrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  min-width: 1200px;
  height: 100%;
  z-index: 0;
  clip-path: ellipse(120% 100% at 50% 100%);
}

.fig-int-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}

.fig-int-header {
  position: relative;
  z-index: 2;
  max-width: 700px;
  margin: 0 auto;
}

.fig-int-title {
  font-family: 'Mulish', sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 50px;
  letter-spacing: -1.6px;
  color: #1D2941;
  text-align: center;
  margin-bottom: 24px;
}

.fig-int-desc {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.80);
  text-align: center;
  margin-bottom: 32px;
}

.fig-int-map {
  position: relative;
  height: 600px;
  max-width: 100%;
  margin: -80px auto 0;
  z-index: 1;
}

.int-node {
  position: absolute;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  transition: transform 0.3s ease, border-color 0.3s ease;
  z-index: 1;
  
  /* 3D Bubble effect for all orbiting nodes */
  background: radial-gradient(circle at 50% 80%, #ffffff 15%, #fff1ea 60%, #ffe0d1 100%);
  border: 1px solid #ffd0bd;
}

.int-node img {
  position: relative;
  z-index: 2;
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* Hover Background Effect */
.int-node:not(.int-center)::after {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(255, 90, 42, 0.25);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
}

.int-node:not(.int-center):hover {
  border-color: #FF5A2A;
  z-index: 10;
}

.int-node:not(.int-center):hover::after {
  opacity: 1;
}

.int-node:not(.int-center):hover img {
  transform: scale(1.1);
}

.int-center {
  width: 180px;
  height: 180px;
  top: 60%;
  left: 50%;
  z-index: 2;
  background: transparent;
  box-shadow: none;
  border: none;
}

/* Orbiting Nodes */
.int-teams { width: 110px; height: 110px; top: 35%; left: 38%; animation: float-orbit-1 8s ease-in-out infinite; }
.int-webhook { width: 90px; height: 90px; top: 35%; left: 62%; animation: float-orbit-2 7s ease-in-out infinite; }
.int-telegram { width: 90px; height: 90px; top: 55%; left: 16%; animation: float-orbit-3 9s ease-in-out infinite; }
.int-slack { width: 90px; height: 90px; top: 70%; left: 73%; animation: float-orbit-1 10s ease-in-out infinite reverse; }
.int-zapier { width: 90px; height: 90px; top: 60%; left: 92%; animation: float-orbit-2 8s ease-in-out infinite reverse; }
.int-bell { width: 65px; height: 65px; top: 28%; left: 18%; animation: float-orbit-3 7s ease-in-out infinite reverse; }
.int-chat { width: 65px; height: 65px; top: 45%; left: 78%; animation: float-orbit-1 9s ease-in-out infinite 1s; }
.int-phone { width: 65px; height: 65px; top: 28%; left: 88%; animation: float-orbit-2 6s ease-in-out infinite 2s; }
.int-email { width: 60px; height: 60px; top: 75%; left: 35%; animation: float-orbit-3 8s ease-in-out infinite 1.5s; }

@keyframes float-orbit-1 {
  0%, 100% { transform: translate(-50%, -50%) translate(0, 0); }
  33% { transform: translate(-50%, -50%) translate(12px, -15px); }
  66% { transform: translate(-50%, -50%) translate(-15px, 8px); }
}

@keyframes float-orbit-2 {
  0%, 100% { transform: translate(-50%, -50%) translate(0, 0); }
  33% { transform: translate(-50%, -50%) translate(-15px, -12px); }
  66% { transform: translate(-50%, -50%) translate(12px, 15px); }
}

@keyframes float-orbit-3 {
  0%, 100% { transform: translate(-50%, -50%) translate(0, 0); }
  33% { transform: translate(-50%, -50%) translate(15px, 12px); }
  66% { transform: translate(-50%, -50%) translate(-12px, -15px); }
}

/* Tooltip Badge */
.node-badge {
  position: absolute;
  bottom: -15px;
  right: calc(100% + 35px);
  white-space: nowrap;
  background: linear-gradient(135deg, #ffffff 0%, #fff2ec 100%);
  border: 2px solid #FF5A2A;
  border-radius: 30px;
  padding: 5px 0px 5px 14px;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(255, 90, 42, 0.15);
  z-index: 3;
  
  /* Animation */
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px) scale(0.95);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.badge-arrow {
  position: absolute;
  top: -20px;
  right: -32px;
  width: 18px;
  height: auto;
  pointer-events: none;
}

.int-node:not(.int-center):hover .node-badge {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
}

@media (max-width: 900px) {
  .fig-int-map {
    transform: scale(0.6);
    transform-origin: top center;
    margin-bottom: -150px;
  }
}
@media (max-width: 600px) {
  .fig-int-map {
    transform: scale(0.4);
    margin-bottom: -240px;
  }
}

/* ===== USE CASES ===== */
.fig-use-cases {
  padding: 0 0 100px;
  background: #ffffff;
}

.fig-use-cases-layout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
}

.fig-use-left {
  flex: 0 0 45%;
  max-width: 550px;
}

.fig-use-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.fig-use-dashboard-img {
  width: 100%;
  max-width: 600px;
  height: auto;
  border-radius: 12px;
  /* Shadow for depth if image doesn't have it */
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.08);
}

.fig-use-header {
  margin-bottom: 25px;
}

.fig-use-title {
  font-family: 'Mulish', sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: #1D2941;
  margin-bottom: 16px;
  line-height: 1.2;
}

.text-slate {
  color: #4A5568;
}

.fig-use-desc {
  font-size: 16px;
  font-weight: 400;
  color: #4A5568;
  line-height: 1.6;
}

/* Decorative Divider */
.use-cases-divider {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 5px;
}
.use-cases-divider .line {
  width: 40px;
  height: 3px;
  background-color: #FF5A2A;
  border-radius: 2px;
}
.use-cases-divider .dot {
  width: 4px;
  height: 4px;
  background-color: #FF5A2A;
  border-radius: 50%;
}

.fig-use-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 35px;
}

.fig-tab {
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #4A5568;
  background: transparent;
  border: 1px solid #E2E8F0;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.2s;
}

.fig-tab-active {
  color: #1D2941;
  background: linear-gradient(to bottom, rgba(248, 65, 9, 0.1) 0%, #FFFFFF 100%);
  border-color: #FFF0EA;
}

.fig-use-content {
  display: flex;
  flex-direction: column;
}

.fig-use-content-title {
  font-family: 'Mulish', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #1D2941;
  margin-bottom: 15px;
}

.fig-use-content-text {
  font-size: 15px;
  font-weight: 400;
  color: #4A5568;
  line-height: 1.6;
  margin-bottom: 15px;
}

.fig-use-benefits {
  margin-top: 10px;
  margin-bottom: 30px;
}

.fig-use-benefits-title {
  font-size: 16px;
  font-weight: 700;
  color: #1D2941;
  margin-bottom: 15px;
}

.fig-use-benefits-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.fig-use-benefit-item {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #E2E8F0;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #2D3748;
}

.benefit-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
}
.benefit-icon svg {
  width: 12px;
  height: 12px;
}
.bg-orange {
  background-color: #FF5A2A;
  color: #fff;
}
.text-orange {
  color: #FF5A2A;
}

/* Secondary CTA Outline */
.fig-cta-outline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  padding: 12px 28px;
  border-radius: 30px;
  border: 1px solid rgba(248, 65, 9, 0.80);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7) 0%, transparent 80%), radial-gradient(172.26% 118.18% at 50% 100%, rgba(248, 65, 9, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), #FFFFFF;
  color: #000000;
  font-weight: 600;
  font-size: 15px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.fig-cta-outline:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.8) 0%, transparent 80%), radial-gradient(172.26% 118.18% at 50% 100%, rgba(248, 65, 9, 0.70) 0%, rgba(255, 255, 255, 0.05) 100%), #FFFFFF;
  box-shadow: 0 4px 15px rgba(255, 90, 42, 0.15);
}

@media (max-width: 1000px) {
  .fig-use-cases-layout {
    flex-direction: column;
    text-align: center;
  }
  .fig-use-left {
    max-width: 100%;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .use-cases-divider {
    justify-content: center;
  }
  .fig-cta-outline {
    align-self: center;
  }
  .fig-use-right {
    width: 100%;
    justify-content: center;
  }
}

/* ===== PRICING ===== */
.fig-pricing {
  position: relative;
  padding: 40px 40px 0;
  background: #ffffff;
}

.fig-pricing-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.fig-pricing-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  opacity: 0.6;
}

.fig-pricing .fig-container {
  position: relative;
  z-index: 1;
}

/* New Container Box */
.fig-pricing-box {
  background: linear-gradient(180deg, #ffffff 0%, #fff7f4 100%);
  border: 1px solid #FFEAE2;
  border-radius: 20px;
  padding: 60px 40px 0;
  margin: 0 auto;
  max-width: 1200px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.02);
  overflow: hidden;
}

.fig-pricing-header {
  text-align: center;
  margin-bottom: 50px;
}

.fig-pricing-title {
  text-align: center;
  font-family: 'Mulish', sans-serif;
  font-size: 40px;
  font-weight: 600;
  color: #1D2941;
  line-height: 50px;
  letter-spacing: -1.6px;
  margin-bottom: 16px;
}

.fig-pricing-desc {
  color: rgba(0, 0, 0, 0.80);
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  max-width: 650px;
  margin: 0 auto;
}

.fig-pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.fig-plan {
  position: relative;
  display: flex;
}

.fig-plan-card {
  position: relative;
  background: radial-gradient(204.56% 148.97% at 50.09% 100%, #FFF 0%, #FFEFEA 65.61%);
  border: 1px solid rgba(248, 65, 9, 0.20);
  border-radius: 24px 24px 0 0;
  padding: 32px;
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: background 0.3s ease, border-color 0.3s ease, border-radius 0.3s ease;
  min-height: 536px;
}

.fig-plan-popular .fig-plan-card, .fig-plan-card:hover {
  background: 
    radial-gradient(circle at top right, rgba(248, 65, 9, 0.12) 0%, transparent 50%),
    radial-gradient(circle at bottom center, rgba(248, 65, 9, 0.15) 0%, transparent 35%),
    #FFFFFF;
  border: 2px solid #F84109;
  border-radius: 28px 28px 0 0;
  transform: none;
  box-shadow: none;
  padding: 31px; /* Offsets the 1px thicker border to prevent layout shift */
}

.fig-plan-header {
  margin-bottom: 0;
}

.fig-plan-name {
  font-family: 'Mulish', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.8px;
  color: rgba(0, 0, 0, 0.80);
}

.fig-plan-badge {
  position: absolute;
  top: 32px;
  right: -1px;
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 60px 0 0 60px;
  border: 1px solid rgba(29, 41, 65, 0.1);
  border-right: none;
  background: radial-gradient(105.62% 76.91% at 50.09% 100%, rgba(255, 255, 255, 0.75) 20%, rgba(255, 255, 255, 0.00) 100%);
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #1D2941;
  white-space: nowrap;
}

.fig-plan-desc {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.80);
  margin-top: 4px;
  min-height: auto;
}

.fig-plan-price-box {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
  margin-bottom: 4px;
}

.fig-plan-offer {
  font-family: 'Mulish', sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 50px;
  letter-spacing: -1.6px;
  background: linear-gradient(95deg, #F84109 64.99%, #F2F5F7 111.97%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.fig-plan-original {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  text-decoration-line: line-through;
  color: rgba(29, 41, 65, 0.40);
}

.fig-plan-offer-text {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.80);
  margin-bottom: 24px;
}

.fig-plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.fig-plan-features li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.80);
  padding: 0;
}

.fig-plan-features li::before {
  content: '';
  display: inline-block;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 4px;
  background-image: url('data:image/svg+xml;utf8,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="9" fill="%23FF5A2A"/><path d="M5 9L8 12L13 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-size: cover;
}

.fig-plan-cta {
  width: 100%;
  padding: 12px 0;
  border-radius: 30px;
  border: 1px solid rgba(248, 65, 9, 0.8);
  background: radial-gradient(172.26% 118.18% at 50% 100%, rgba(248, 65, 9, 0.5) 0%, rgba(255, 255, 255, 0) 100%), #FFFFFF;
  color: #1D2941;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.fig-plan-cta:hover {
  background: radial-gradient(172.26% 118.18% at 50% 100%, rgba(248, 65, 9, 0.8) 0%, rgba(255, 255, 255, 0.4) 100%);
}

@media (max-width: 900px) {
  .fig-pricing-grid {
    grid-template-columns: 1fr;
  }
}

/* ===== REVIEWS ===== */
.fig-reviews {
  padding: 100px 40px;
  background: transparent url('../assets/images/landing/figma/review-section-bg.png') no-repeat center bottom;
  background-size: 100% auto;
}

.fig-reviews-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 50px;
}

.fig-reviews-tag {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 60px;
  border: 1px solid rgba(29, 41, 65, 0.10);
  background: radial-gradient(124.43% 90.61% at 50.09% 100%, rgba(248, 65, 9, 0.05) 34.39%, rgba(255, 255, 255, 0.00) 100%);
  font-size: 13px;
  font-weight: 500;
  color: #4A5568;
  margin-bottom: 15px;
}

.fig-reviews-title {
  font-family: 'Mulish', sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 50px;
  letter-spacing: -1.6px;
  color: #1D2941;
}

.fig-reviews-title .text-slate {
  background: linear-gradient(95deg, #1D2941 64.99%, #F2F5F7 111.97%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.fig-reviews-nav {
  display: flex;
  gap: 12px;
  margin-bottom: 10px;
}

.fig-nav-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #4A5568;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.fig-nav-next {
  background: #FFF0EA;
  border-color: #FF5A2A;
  color: #FF5A2A;
}

.fig-nav-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
}

.fig-reviews-grid {
  column-count: 3;
  column-gap: 20px;
}

.fig-review-card {
  break-inside: avoid;
  margin-bottom: 20px;
  border-radius: 16px;
  border: 1px solid rgba(29, 41, 65, 0.10);
  background: linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, transparent 60%), radial-gradient(ellipse at bottom center, rgba(248, 65, 9, 0.125) 0%, rgba(255, 255, 255, 0) 100%), #FFFFFF;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.02);
  transition: transform 0.3s ease;
}

.fig-review-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 15px 35px rgba(255, 90, 42, 0.05);
}

.review-quote-icon {
  width: 26px;
  height: auto;
  margin-bottom: 15px;
  display: block;
}

.review-text {
  font-size: 16px;
  color: #4A5568;
  line-height: 1.6;
  margin-bottom: 25px;
}

.review-author h4 {
  font-size: 18px;
  font-weight: 600;
  color: #1D2941;
  margin-bottom: 4px;
}

.review-author p {
  font-size: 12px;
  font-weight: normal;
  font-style: italic;
  color: black;
}

@media (max-width: 900px) {
  .fig-reviews-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
  .fig-reviews-grid {
    column-count: 2;
  }
}

@media (max-width: 600px) {
  .fig-reviews-grid {
    column-count: 1;
  }
}

/* ===== FAQ ===== */
.fig-faq {
  padding: 100px 40px;
  background: #ffffff;
}

.fig-faq-layout {
  display: flex;
  gap: 80px;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
}

.fig-faq-sidebar {
  flex: 0 0 420px;
  position: sticky;
  top: 120px; /* Adjust based on header height */
  align-self: flex-start;
}

.fig-faq-title {
  font-family: 'Mulish', sans-serif;
  font-size: 50px;
  font-weight: 600;
  line-height: 60px;
  letter-spacing: -2px;
  color: #1D2941;
  margin-bottom: 20px;
}

.fig-faq-gradient-text {
  background: linear-gradient(95deg, #1D2941 64.99%, #F2F5F7 111.97%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.fig-faq-card {
  background: radial-gradient(141.72% 90.61% at 50.09% 100%, rgba(255, 255, 255, 0.00) 0%, rgba(248, 65, 9, 0.04) 100%), #FFFFFF;
  border: 1px solid rgba(29, 41, 65, 0.20);
  border-radius: 16px;
  padding: 30px 25px;
  margin-top: 30px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.02);
}

.fig-faq-card h4 {
  font-size: 18px;
  font-weight: 700;
  color: #1D2941;
  margin-bottom: 10px;
}

.fig-faq-card p {
  font-size: 15px;
  color: #4A5568;
  line-height: 1.5;
  margin-bottom: 25px;
}

.fig-faq-contact-btn {
  display: inline-block;
  padding: 12px 28px;
  background: #1D2941;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.fig-faq-contact-btn:hover {
  background: #FF5A2A;
}

.fig-faq-accordion {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 650px;
  margin-left: auto;
}

.fig-faq-item {
  border-bottom: 1px solid #E2E8F0;
}

.fig-faq-question {
  width: 100%;
  background: transparent;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0; /* adjusted vertical padding */
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  cursor: pointer;
  text-align: left;
}

.fig-faq-active .fig-faq-question {
  color: #000000;
}

.fig-faq-icon {
  width: 16px;
  height: 16px;
  display: inline-block;
  flex-shrink: 0;
  background: linear-gradient(135deg, #F84109 0%, rgba(248, 65, 9, 0.5) 100%);
  -webkit-mask-image: url('../assets/images/landing/figma/plus-icon.svg');
  mask-image: url('../assets/images/landing/figma/plus-icon.svg');
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  transition: transform 0.3s ease, background 0.3s ease;
}

.fig-faq-active .fig-faq-icon {
  background: #1D2941;
  transform: rotate(45deg);
}

.fig-faq-answer {
  padding-bottom: 12px; /* reduced spacing */
}

.fig-faq-answer p {
  font-size: 16px; /* adjusted per request */
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 900px) {
  .fig-faq-layout {
    flex-direction: column;
    gap: 40px;
  }
  .fig-faq-sidebar {
    flex: none;
    width: 100%;
  }
}

/* ===== BOTTOM HERO ===== */
.fig-bottom-hero {
  position: relative;
  padding: 110px 40px 0;
  background: #ffffff;
  text-align: center;
  overflow: hidden;
}

.fig-bh-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  pointer-events: none;
}

.fig-bh-bg-img {
  width: 100%;
  height: auto;
  max-width: 1440px;
  object-fit: cover;
  object-position: top center;
}

.fig-bh-content {
  position: relative;
  z-index: 2;
  max-width: 1000px;
  margin: 0 auto;
}

.fig-bh-grade-container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: -100px auto 0;
}

.fig-bh-grade-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  -webkit-mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
}

.fig-bh-title {
  text-align: center;
  font-family: 'Mulish', sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 50px;
  letter-spacing: -1.6px;
  color: #1D2941;
  margin-bottom: 20px;
}

.fig-bh-gradient-text {
  background: linear-gradient(95deg, #1D2941 64.99%, #F2F5F7 111.97%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.fig-bh-desc {
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.80);
  margin-bottom: 40px;
}

.fig-bh-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.fig-bh-btn {
  padding: 12px 30px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.fig-bh-btn-secondary {
  background: #ffffff;
  color: #1D2941;
  border: 1px solid #E2E8F0;
}

.fig-bh-btn-secondary:hover {
  background: #f8fafc;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
}

.fig-bh-btn-primary {
  background: linear-gradient(135deg, #ffffff 0%, #fff0ea 100%);
  color: #1D2941;
  border: 1px solid #FF5A2A;
}

.fig-bh-btn-primary:hover {
  background: #FFEAE2;
  box-shadow: 0 4px 15px rgba(255, 90, 42, 0.15);
}

.fig-bh-faded {
  position: relative;
  z-index: 1;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  -webkit-mask-image: linear-gradient(to right, transparent, black 20%, black 80%, transparent);
  mask-image: linear-gradient(to right, transparent, black 20%, black 80%, transparent);
  padding-bottom: 20px;
  margin-top: -60px;
}

@keyframes marqueeRightToLeft {
  0% { transform: translateX(0%); }
  100% { transform: translateX(-50%); }
}

.marquee-track {
  display: flex;
  white-space: nowrap;
  animation: marqueeRightToLeft 60s linear infinite;
  width: fit-content;
}

.fig-bh-faded-text {
  display: inline-block;
  font-family: 'Mulish', sans-serif;
  font-size: 65px;
  font-weight: 700;
  line-height: 70px;
  letter-spacing: -2.6px;
  color: rgba(248, 65, 9, 0.10);
  margin: 0;
  padding-right: 50px;
}

/* ===== FOOTER ===== */
.fig-footer {
  position: relative;
  background-image: url('../assets/images/landing/figma/footer-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  padding: 30px 40px;
  overflow: hidden;
}

.fig-footer-content {
  position: relative;
  z-index: 1;
}

.fig-footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.fig-footer-copyright {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.80);
  margin: 0;
}

.fig-footer-legal-links {
  display: flex;
  gap: 24px;
}

.fig-footer-link {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.80);
  text-decoration: none;
  transition: color 0.3s ease;
}

.fig-footer-link:hover {
  color: #F84109;
}

@media (max-width: 900px) {
  .fig-footer-links {
    flex-direction: column;
  }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 1200px) {
  .fig-hero-container {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .fig-hero-content {
    align-items: center;
  }

  .fig-hero-title {
    font-size: 48px;
  }

  .fig-services-grid {
    grid-template-columns: repeat(2, 1fr);
  }



  .fig-status-grid {
    grid-template-columns: 1fr;
  }

  .fig-pricing-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .fig-footer-links {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .fig-header-inner, .fig-header-inner-new {
    padding: 12px 16px;
  }

  .fig-nav {
    display: none;
  }

  /* Global Paddings & Containers */
  .fig-hero { padding: 80px 16px 40px; }
  .fig-services-new { padding: 40px 16px 0; }
  .fig-status { padding: 40px 16px; }
  .fig-use-cases { padding: 40px 16px; }
  .fig-integrations-new { padding: 40px 16px 0; }
  .fig-pricing { padding: 40px 16px 0; }
  .fig-reviews { padding: 40px 16px; }
  .fig-bottom-hero { padding: 60px 16px; }
  .fig-footer { padding: 40px 16px 20px; }
  .fig-container, .fig-container-new { padding: 0 16px; box-sizing: border-box; }

  /* Hero */
  .fig-hero-title, .fig-hero-title-new { font-size: 32px; line-height: 40px; }
  .fig-hero-buttons { flex-direction: column; }
  
  /* Services */
  .fig-services-grid, .fig-service-grid { grid-template-columns: 1fr; gap: 16px; }
  
  /* Use Cases / Benefits */
  .fig-use-benefits-grid { grid-template-columns: 1fr !important; }
  .fig-use-cases-layout { flex-direction: column; gap: 30px; text-align: center; }
  .fig-use-left { max-width: 100%; flex: auto; }
  .fig-use-right { justify-content: center; width: 100%; }
  .fig-use-tabs-wrapper { flex-wrap: wrap !important; width: 100% !important; justify-content: center !important; }
  .fig-use-tabs { flex-wrap: wrap; justify-content: center; }
  .fig-use-title { font-size: 32px; line-height: 40px; }
  .fig-use-benefit-item { white-space: normal !important; text-align: left; }
  
  /* Status Pages & Use Cases */
  .fig-status-grid { grid-template-columns: 1fr; gap: 40px; }
  .fig-status-content { padding-left: 0; align-items: center; text-align: center; }
  .use-cases-divider { justify-content: center; width: 100%; }
  .fig-status-composition { max-width: 100%; }
  .fig-status-image {
    justify-content: center !important;
    margin-right: 0 !important;
  }
  .fig-status-image > div {
    transform: scale(0.8);
    transform-origin: center;
  }

  /* Integrations */
  .fig-int-map { 
    width: 1000px; 
    max-width: 1000px; 
    margin-left: 50%; 
    transform: translateX(-50%) scale(0.35); 
    transform-origin: top center; 
    margin-top: -20px; 
    margin-bottom: -400px; 
  }
  .fig-int-title { font-size: 28px; line-height: 36px; }

  /* Pricing */
  .fig-pricing-grid { grid-template-columns: 1fr; gap: 16px; }
  
  /* Reviews */
  .fig-reviews-header { flex-direction: column; align-items: flex-start; gap: 16px; }
  .fig-reviews-title { font-size: 28px; line-height: 36px; }
  .fig-review-cards { flex-direction: column; }
  .fig-reviews-grid { column-count: 1; }

  /* Bottom Hero */
  .fig-bh-faded-text { font-size: 28px; line-height: 36px; }
  .fig-bh-title { font-size: 28px; line-height: 36px; }

  /* Footer */
  .fig-footer-links { grid-template-columns: 1fr; gap: 20px; }
  .fig-footer-buttons { flex-direction: column; }
  .fig-footer-bottom { flex-direction: column; gap: 16px; align-items: center; text-align: center; }
}

/* Global Font & Heading Overrides */
* {
  font-family: 'Mulish', sans-serif !important;
}

.fig-feature-title,
.fig-section-title-new,
.fig-status-title,
.fig-use-title,
.fig-pricing-title,
.fig-faq-question,
.fig-faq-title,
.fig-footer-title,
.fig-bh-title,
.fig-reviews-title {
  font-weight: 500 !important;
}

h1, h2, h3, h4, h5, h6,
.fig-hero-title-new,
.fig-feature-title,
.fig-section-title-new,
.fig-status-title,
.fig-use-title,
.fig-pricing-title,
.fig-faq-question,
.fig-faq-title,
.fig-footer-title,
.fig-bh-title,
.fig-reviews-title {
  letter-spacing: -0.04em !important;
}
</style>
